import { Alert, Button, Modal, Spinner } from "react-bootstrap";
import { WfsPaymentRequiredResponse } from "../../../types/Wfs/WfsResponse";
import { useNavigate, useLocation } from "react-router-dom";
import Price from "../../../@ui/Price";
import { useDataSelectionContext } from "../DataSelectionContext";
import { useApiContext } from "../../api/ApiContext";
import { useAuthContext } from "../../auth/AuthContext";
import { LocalStorageKeys } from "../../../types/LocalStorageKeys";
import { DateTime } from "luxon";
import { PendingPremiumOrder } from "../../../types/PendingPremiumOrder";

export interface PaymentRequiredViewProps {
  paymentRequired: WfsPaymentRequiredResponse;
}

const PaymentRequiredView = ({
  paymentRequired,
}: PaymentRequiredViewProps) => {
  const { id, description, priceExTax, transactionCurrencyCode } =
    paymentRequired;
  const navigate = useNavigate();
  const location = useLocation();
  const { loading, addToBasket } = useDataSelectionContext();
  const { abort } = useApiContext();
  const { user } = useAuthContext();

  const cancel = () => {
    if (loading) abort();
    navigate("/");
  };

  const handleLoginRequired = () => {
    // Store the complete quote with UTC timestamp in localStorage
    const pendingOrder: PendingPremiumOrder = {
      timestamp: DateTime.utc().toISO(),
      quote: paymentRequired,
      redirectPath: location.pathname,
    };
    localStorage.setItem(
      LocalStorageKeys.PENDING_PREMIUM_ORDER,
      JSON.stringify(pendingOrder)
    );

    // Navigate to login with redirect back to current page
    navigate(`/login?redirect=${location.pathname}`);
  };

  return (
    <>
      <Modal.Body>
        <Alert variant="warning">
          This is a Premium dataset and will require additional payment.
        </Alert>
        {!user && (
          <Alert variant="info">
            This price is approximate. The final price may change once you log
            in due to currency conversion or licencing requirements.
          </Alert>
        )}
        <div>
          <strong>Description</strong>: {description}
        </div>
        <div>
          <strong>Price</strong>*:{" "}
          <Price currencyCode={transactionCurrencyCode} price={priceExTax} />
        </div>
        <small>*exclusive of tax</small>
      </Modal.Body>
      <Modal.Footer>
        {user ? (
          <Button
            variant="success"
            onClick={() => addToBasket(id)}
            disabled={loading}>
            Add to Basket {loading && <Spinner size="sm" />}
          </Button>
        ) : (
          <Button variant="secondary" onClick={handleLoginRequired}>
            Login to Purchase
          </Button>
        )}
        <Button variant="danger" onClick={cancel}>
          Cancel
        </Button>
      </Modal.Footer>
    </>
  );
};

export default PaymentRequiredView;
